import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import CONFIG from 'shared/constants/config';
import authWsModel from 'store/models/authWs';

declare global {
  interface Window {
    Pusher: unknown;
    Echo: Echo;
  }
}

window.Pusher = Pusher;

export function createSocketConnection() {
  if (!window.Echo) {
    window.Echo = new Echo({
      broadcaster: 'pusher',
      key: CONFIG.REACT_APP_API_PUSHER_APP_KEY,
      wsHost: CONFIG.REACT_APP_API_WS_BASE_URL,
      wssHost: CONFIG.REACT_APP_API_WS_BASE_URL,
      wsPort: CONFIG.REACT_APP_API_WS_BASE_PORT,
      wssPort: CONFIG.REACT_APP_API_WS_BASE_PORT,
      forceTLS: true,
      encrypted: true,
      disableStats: false,
      enabledTransports: ['ws', 'wss'],
      cluster: 'eu',
      app_id: CONFIG.REACT_APP_API_PUSHER_APP_ID,
      authorizer: (channel, options) => {
        return {
          authorize: (socketId, callback) => {
            authWsModel
              .postWsAuth<{ data: any }>({
                socketId,
                channelName: channel.name,
              })
              .then(response => {
                callback(false, response.data);
              })
              .catch(error => {
                console.log('error', error);
                callback(true, error);
              });
          },
        };
      },
    });
  }
}
